import React from 'react';

import { flagStyles } from '../settings';

const SvgTC = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5088px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTC;
